import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Divider from '../../../components/Divider';
import TestCard from '../../../components/TestCard';
import TreatmentCard from '../../../components/TreatmentCard';

import { ButtonText } from '../../../components/Typography';
import { FormattedMessage } from 'react-intl';

import './index.scss';

const MyHealthYourProducts = ({ tests, treatments, handleOpenBottomModal }) => {
  const sortedTestsByResultsViewedAndLastUpdate = tests.sort((a, b) => {
    const aResultsViewed = a.resultsViewed === null ? true : a.resultsViewed;
    const bResultsViewed = b.resultsViewed === null ? true : b.resultsViewed;
    if (aResultsViewed === bResultsViewed) {
      return new Date(b.lastUpdate) - new Date(a.lastUpdate);
    }
    return aResultsViewed ? 1 : -1;
  });

  return (
    <>
      <Divider
        title={
          <FormattedMessage
            id='my-health.your-products'
            defaultMessage='Your Products'
          />
        }
      />
      {treatments && treatments.length > 0 && (
        <div className='my-health-your-products__treatments'>
          {treatments.map((treatment, index) => (
            <TreatmentCard
              key={`tr-${index}`}
              iconUrl={treatment.iconUrl}
              type={treatment.type}
              testCode={treatment.testCode}
              startDate={treatment.startDate}
              doctorName={treatment.doctorName}
              activeStepId={treatment.activeStepId}
              id={treatment.id}
              steps={treatment.steps}
            />
          ))}
        </div>
      )}
      {sortedTestsByResultsViewedAndLastUpdate && (
        <div
          className={cx('my-health-your-products__products', {
            'my-health-your-products__products--with-treatments':
              treatments && treatments.length > 0,
          })}
        >
          {sortedTestsByResultsViewedAndLastUpdate
            .slice(0, 3)
            .map((test, index) => (
              <TestCard
                key={`t-${index}`}
                iconUrl={test.iconUrl}
                type={test.type}
                status={test.status}
                activationFlowUrl={test.activationFlowUrl}
                code={test.code}
                partnerCode={test.partnerCode}
                lastUpdate={test.lastUpdate}
                personName={test.personName}
                reorderUrl={test.reorderUrl}
                reorderDiscount={test.reorderDiscount}
                testResultsUrl={test.testResultsUrl}
                bookingData={test.bookingData}
                samplingInstructionsUrl={test.samplingInstructionsUrl}
                updateSamplingTimeUrl={test.updateSamplingTimeUrl}
                takeSampleUrl={test.takeSampleUrl}
                handleMoreDetails={() => handleOpenBottomModal(test)}
                resultsViewed={test.resultsViewed}
                labData={test.labData}
              />
            ))}
        </div>
      )}
      <Link
        to='/myhealth/products'
        className='my-health-your-products__view-all'
      >
        <ButtonText>
          <FormattedMessage id='my-health.view-all' defaultMessage='View all' />
        </ButtonText>
      </Link>
    </>
  );
};

MyHealthYourProducts.propTypes = {
  tests: PropTypes.array,
  treatments: PropTypes.array,
  handleOpenBottomModal: PropTypes.func,
};

export default MyHealthYourProducts;
